import api from './api';

export interface DeliveryProof {
    orderId: string;
    orderNumber: string;
    orderStatus: string;
    assignedTo: {
        id: string;
        name: string;
        mobile: string;
    } | null;
    deliveryProof: {
        photoUrl: string | null;
        signatureUrl: string | null;
        signaturePdfUrl: string | null;
        photoUploadedAt: string | null;
        signatureUploadedAt: string | null;
    } | null;
}

export interface DeliveryProofListResponse {
    success: boolean;
    data: DeliveryProof[];
    message: string;
}

export interface SingleDeliveryProofResponse {
    success: boolean;
    data: DeliveryProof;
    message: string;
}

export const getDeliveryProofList = async (): Promise<DeliveryProofListResponse> => {
    const response = await api.get('/delivery/orders/proof');
    return response.data;
};

export const getDeliveryProof = async (orderId: string): Promise<SingleDeliveryProofResponse> => {
    const response = await api.get(`/delivery/order/${orderId}/proof`);
    return response.data;
};
